import { useEffect, useState } from "react";
import { Bookmark, BookmarkCheck } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/lib/i18n";
import { isSaved, saveArticle, removeSaved } from "@/lib/savedArticles";
import { sendReaderEvent, newOpId } from "@/lib/readerEvents";

/** «حفظ الخبر» next to the share buttons. The event is sent only AFTER the local write is verified. */
export default function SaveButton({ article }) {
    const { t, lang } = useLang();
    const [saved, setSaved] = useState(() => isSaved(article.id));
    useEffect(() => {
        setSaved(isSaved(article.id));
        const refresh = () => setSaved(isSaved(article.id));
        window.addEventListener("saved:change", refresh);
        return () => window.removeEventListener("saved:change", refresh);
    }, [article.id]);

    const toggle = () => {
        if (saved) {
            const r = removeSaved(article.id);
            if (!r.ok) { toast.error(t("saveFail")); return; }
            setSaved(false); toast(t("unsaved"));
            sendReaderEvent("unsave", { articleId: article.id, slug: article.slug, lang, opId: newOpId() });
        } else {
            const r = saveArticle({ id: article.id, slug: article.slug, title: article.title });
            if (!r.ok) { toast.error(t("saveFail")); return; }
            setSaved(true); toast.success(t("savedDone"), { description: t("savedNote") });
            sendReaderEvent("save", { articleId: article.id, slug: article.slug, lang, opId: newOpId() });
        }
    };

    return (
        <button type="button" onClick={toggle} aria-pressed={saved} data-saved={saved ? "1" : "0"}
            className={`inline-flex items-center gap-2 text-xs font-bold px-3 py-2 rounded-sm border transition-colors min-h-[36px] ${saved ? "bg-brand-red text-white border-brand-red hover:bg-brand-red-dark" : "border-gray-300 dark:border-gray-600 text-brand-black dark:text-gray-100 hover:border-brand-red hover:text-brand-red"}`}
            data-testid="save-article-button" title={saved ? t("savedDone") : t("saveArticle")}>
            {saved ? <BookmarkCheck className="w-4 h-4" /> : <Bookmark className="w-4 h-4" />}
            {saved ? t("savedDone") : t("saveArticle")}
        </button>
    );
}
